import Modal from '../modal/modal'
import { type Nullable } from '../../types/common'

export class PopupCookie extends Modal {
  connectedCallback(): void {
    if (this.isEditorMode) {
      this.editor.subscribe('BLOCK_SELECT', this._handleBlockSelect)
      this.editor.subscribe('BLOCK_DESELECT', this._handleBlockDeselect)
      return
    }

    window.Shopify.loadFeatures?.(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          throw error
        }

        const userCanBeTracked =
          window.Shopify.customerPrivacy?.userCanBeTracked()
        const userTrackingConsent =
          window.Shopify.customerPrivacy?.getTrackingConsent()

        if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.show()
        }
      },
    )
  }

  disconnectedCallback(): void {
    if (this.isEditorMode) {
      this.editor.destroy()
    }
  }

  _handleBlockSelect = ({ detail: { blockId } }): void => {
    if (this.dataset.blockId === blockId) {
      this.show()
    }
  }

  _handleBlockDeselect = ({ detail: { blockId } }): void => {
    if (this.dataset.blockId === blockId) {
      this.hide()
    }
  }

  show = async (): Promise<void> => {
    await super.show()
    this.selectBtn('accept')?.addEventListener('click', this.onAccept)
    this.selectBtn('decline')?.addEventListener('click', this.onDecline)
    this.selectBtn('close')?.addEventListener('click', this.onDecline)
  }

  hide = async (): Promise<void> => {
    this.selectBtn('accept')?.removeEventListener('click', this.onAccept)
    this.selectBtn('decline')?.removeEventListener('click', this.onDecline)
    this.selectBtn('close')?.removeEventListener('click', this.onDecline)
    await super.hide()
  }

  onAccept = (): void => {
    if (this.isEditorMode) {
      this.hide()
      return
    }

    window.Shopify.customerPrivacy?.setTrackingConsent(true, this.hide)
  }

  onDecline = (): void => {
    if (this.isEditorMode) {
      this.hide()
      return
    }

    window.Shopify.customerPrivacy?.setTrackingConsent(false, this.hide)
  }

  selectBtn(type: 'accept' | 'decline' | 'close'): Nullable<HTMLElement> {
    if (!this.isOpen) {
      return null
    }

    return this.querySelector(`[data-${type}-btn]`)
  }
}
